import { Helmet } from "react-helmet";
import LandingLayout from "../sections/landing/landingLayout";

const LandingPage = () => {
    <Helmet>
        <title>Edliena | Learn With Cuddles</title>
        <meta name="description" content="Say hello to Cuddles the penguin! A fun, child-friendly game where kids learn numbers 0-10 by tracing, recognizing, and catching fish in playful levels. Math turns into an adventure full of joy, giggles, and learning!" />
        <meta name="keywords" content="Learn with Cuddles, Cuddles the penguin, kids math game, numbers 0-10, number tracing, number recognition, counting fun, math adventure, educational games for kids, preschool math, early learning, fun with numbers, penguin learning game, playful learning, kids educational activities" />
        <link rel="canonical" href="https://cuddles.edliena.com/" />
    </Helmet>

    return (
        <>
            <LandingLayout />
        </>
    );
}

export default LandingPage;